import React from "react";
import "./Vision_Mission.css";
const Vision_Mission = () => {
  return (
    <section className="vision-mission-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="vm-card">
              <h3 className="vm-title">
                <span className="vm-icon"></span> OUR VISION
              </h3>
              <p className="vm-text">
                We envision becoming the top transportation partner for all your
                travel needs, offering unparalleled service & satisfaction. Our
                goal is to set new benchmarks for quality in the cab & transport
                service industry.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="vm-card">
              <h3 className="vm-title">
                <span className="vm-icon"></span> OUR MISSION
              </h3>
              <p className="vm-text">
                To provide safe, reliable, & efficient transportation solutions
                that exceed customer expectations. We are committed to delivering
                top-notch service with every ride.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
export default Vision_Mission;
